<template>
  <div class="terms-conditions" v-if="hasFieldsValue">
    <h2 class="title">{{$t('PERKS_TERMS_AND_CONDITIONS_HEADER')}}</h2>
    <sc-rich-text tag="div" class="paragraph rich-text-block" :field="fields.termsAndConditions"/>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { RichText } from '@sitecore-jss/sitecore-jss-vue'

const { mapGetters: mapJssGetters } = createNamespacedHelpers('jss')

export default {
  name: 'TermsAndConditions',

  props: {
    fields: {
      type: Object
    }
  },

  components: {
    ScRichText: RichText
  },

  computed: {
    ...mapJssGetters(['isEditMode']),

    hasTermsAndConditions () {
      const { termsAndConditions } = this.fields

      return termsAndConditions && termsAndConditions.value
    },

    hasFieldsValue () {
      return !!(this.isEditMode || this.hasTermsAndConditions)
    }
  }
}
</script>

<style lang="scss" scoped>

.title {
  @include font('080');

  font-weight: 600;
  color: $color_gray_2;
}

.paragraph {
  @include font('060');

  font-stretch: normal;
  letter-spacing: normal;
  color: $color_gray_2;
  margin: $space-060 0;

  @include tablet {
    margin-top: $space-070;
  }
}

</style>
